type PanelContentActivityOptions = {
    activeIndex: number | null | undefined
    hidden: boolean
    numPanels: number
    panelIndex: number | null | undefined
    prewarmPanelIndex?: number | null
}

export function shouldKeepPanelContentActive({
    activeIndex,
    hidden,
    numPanels,
    panelIndex,
    prewarmPanelIndex = null,
}: PanelContentActivityOptions) {
    if (hidden) return false
    if (panelIndex == null || activeIndex == null) return true
    if (numPanels === 1) {
        return panelIndex === activeIndex || panelIndex === prewarmPanelIndex
    }
    if (numPanels === 3) {
        return panelIndex >= activeIndex && panelIndex < activeIndex + numPanels
    }
    return true
}

type ThreadPostListActivityOptions = {
    editingAnswerCount: number
    hasActiveDrag: boolean
    panelContentActive: boolean
}

export function shouldKeepThreadPostListActive({
    editingAnswerCount,
    hasActiveDrag,
    panelContentActive,
}: ThreadPostListActivityOptions) {
    return panelContentActive || hasActiveDrag || editingAnswerCount > 0
}
